import React from "react";
import TextField from "./Fields/TextField/TextField";
import { UseFormReturn, FieldValues, FieldError } from "react-hook-form";
import Description from "./components/Description/Description";
import Error from "./components/Error/Error";
import Label from "./components/Label/Label";
import DateField from "./Fields/Date/DateField";
import SelectableField from "./Fields/SelectableField/SelectableField";
import TimeField from "./Fields/Time/TimeField";
import FileUploadField from "./Fields/FileUploadField/FileUploadField";
import { FieldType, FormField, TextObject, WuiltContext } from "@/shared/types";

const FieldsComponentMapper = {
  [FieldType.Text]: TextField,
  [FieldType.Email]: TextField,
  [FieldType.Phone]: TextField,
  [FieldType.Link]: TextField,
  [FieldType.TextArea]: TextField,
  [FieldType.Date]: DateField,
  [FieldType.Checkbox]: SelectableField,
  [FieldType.Radio]: SelectableField,
  [FieldType.Time]: TimeField,
  [FieldType.Select]: SelectableField,
  [FieldType.File]: FileUploadField,
} as any;

interface FieldViewProps {
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  formId: string;
  uploadFileUrl: (formId?: string, sectionId?: string) => string;
  sectionId?: string;
  sectionValueId?: string;
  formSubmitSucceeded?: boolean;
  text: TextObject;
  elementId?: string;
  wuiltContext: WuiltContext;
}

const FieldView: React.FC<FieldViewProps> = ({
  field,
  uploadFileUrl,
  useFormProps,
  isSubmitting,
  formId,
  sectionId,
  sectionValueId,
  formSubmitSucceeded,
  text,
  elementId,
  wuiltContext,
}) => {
  const error = useFormProps?.formState?.errors?.[field?.id];
  const { label, description, errorMessage } = field?.settings || {};
  const Component = FieldsComponentMapper[field.type!];
  return (
    <div>
      <Label
        isError={!!error}
        label={text[label?.textId!]}
        htmlFor={field?.id}
      />
      <Description isError={!!error} description={text[description?.textId!]} />
      <Component
        sectionId={sectionId}
        sectionValueId={sectionValueId}
        uploadFileUrl={uploadFileUrl}
        key={field?.id}
        isError={!!error}
        field={field}
        useFormProps={useFormProps}
        isSubmitting={isSubmitting}
        formId={formId}
        formSubmitSucceeded={formSubmitSucceeded}
        text={text}
        elementId={elementId}
        wuiltContext={wuiltContext}
      />
      <Error
        error={error as FieldError}
        errorMessage={text[errorMessage?.textId!]}
      />
    </div>
  );
};

export default FieldView;
